<template>
  <path
    d="M10.59 4.59024C10.21 4.21024 9.7 4.00024 9.17 4.00024H4C2.9 4.00024 2.01 4.90024 2.01 6.00024L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V8.00024C22 6.90024 21.1 6.00024 20 6.00024H12L10.59 4.59024Z"
  />
</template>
